<!--
 * @Description: 富文本，单行，超链接
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <!-- 主属性 -->
  <template v-if="props.params?.mainField && params?.fieldValue && params?.sourceType != 2">
    <!-- 列表 -->
    <div class="text-field-edit main-field" :class="{ 'is-special-product': isSpecialProduct }">
      <fh-ellipsis :content="params?.fieldValue" @click.stop="handleDetail" :wrapHeight="params.rowHeight" :link="true" />
    </div>
    <!-- 客户特殊处理--详情 -->
    <template v-if="params.entity == 2 && params?.sourceType == 2 && params?.row?.isDealt">
      <div class="custom-name-tag-width">
        <jw-tag size="small" class="custom-name-tag-width-tag" v-if="userInfo?.orgId == huaYingOrdId" :color="params?.row?.isDealt == '出资一次' || params?.row?.isDealt == '出资多次' ? 'green' : 'pinkpurple'">{{ $t(params.row.isDealt) }}</jw-tag>
        <template v-else>
          <jw-tag size="small" class="custom-name-tag-width-tag" v-if="params?.row?.isDealt == '成交一次' || params?.row?.isDealt == '成交多次'" color="green">{{ $t(params.row.isDealt) }}</jw-tag>
        </template>
      </div>
    </template>
  </template>
  <!-- 富文本 -->
  <ly-rich-text v-else-if="params?.fieldType == 26" :fieldValue="params?.fieldValue" :isSingleLine="params?.sourceType != 2 ? true : false" :rowHeight="params.rowHeight"></ly-rich-text>
  <!-- 其他类型 -->
  <template v-else>
    <template v-if="params?.fieldKey == 'qccId'">
      <jw-tag size="small" :color="params?.fieldValue ? 'green' : 'pink'">{{ params?.fieldValue ? $t('是') : $t('否') }}</jw-tag>
    </template>
    <!-- 飞书合同 -->
    <template v-else-if="params?.fieldKey == 'fsContractId'">
      <template v-if="params.entity === 10">
        <jw-link @click="openFSDetails(params.row)" v-if="params.row?.fs_contract_code?.fieldValue">{{ params.row?.fs_contract_code?.fieldValue }}</jw-link>
        <template v-else>-</template>
      </template>
      <template v-else>
        <!-- 2024/05/17 下午14:19，柳沛让前端拼接跳转路径 -->
        <template v-if="params.row?.fsContractId">
          <jw-link @click.stop="" v-if="tools.isJSON(params.row.fsContractMultiUrl) && JSON.parse(params.row.fsContractMultiUrl)?.pc_url" :href="JSON.parse(params.row.fsContractMultiUrl)?.pc_url" target="_blank">{{ params.row.fsContractId }}</jw-link>
          <span v-else>{{ params.row.fsContractId }}999</span>
        </template>
        <span v-else>-</span>
      </template>
    </template>
    <template v-else>
      <div class="text-field-edit" v-if="params?.sourceType != 2">
        <fh-ellipsis :content="params?.fieldValue" :wrapHeight="params.rowHeight" />
      </div>
      <template v-else>
        <div class="detail-text-field">
          <!-- 详情 -->
          {{ params?.fieldValue }}
        </div>
      </template>
    </template>
  </template>
</template>

<script setup>
import { inject } from 'vue';
import { tools } from '@/utils/tools';
import { Message } from '@arco-design/web-vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
import { huaYingOrdId } from '@/utils/const';
import { useUserStore } from '@/store';
import FhEllipsis from '@/components/fh-ellipsis/index.vue';
//优先判断多层级
const toDetails = inject('nestTableMethods')?.toDetails ?? inject('mainTableMethods')?.toDetails;
const { userInfo } = useUserStore(); //用户信息
const props = defineProps({
  params: {
    type: Object,
    default: () => {}
  }
});

// 特殊产品详情页表格主属性字段不可跳转详情
const isSpecialProduct = inject('defaultParams')?.isSpecialProduct;

const handleDetail = () => {
  toDetails({ ...props.params?.row, mask: props.params.mask });
};

if (props.params?.fieldKey == 'fsContractId') {
  console.log('props.params', props.params);
}

const isFeiShuApp = window.h5sdk;
const openFSDetails = (record) => {
  if (!record.fsContractId) {
    Message.warning(t('tips.noFeishu'));
    return;
  }
  if (record.fsContractMultiUrl) {
    const fsContractMultiUrl = JSON.parse(record.fsContractMultiUrl);
    if (isFeiShuApp) {
      //移动端--飞书环境
      window.open(fsContractMultiUrl.sidebar_url);
    } else {
      window.open(fsContractMultiUrl.pc_url);
    }
  }
};
</script>
<style scoped lang="less">
@import './text-field.less';
</style>
